import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {DuluxLocationPagesWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/duluxLocationPagesWorkspaceCapability/domain/DuluxLocationPagesWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";
export type DuluxLocationPagesWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.duluxLocationPages> & {
    fixedUdoTemplates: {
        [DuluxLocationPagesWorkspaceCapabilityUdoTemplateKey.locationPage]: {
            udoAdditionalColumnIds: {
                cityName: Uuid;
                content: Uuid;
                defaultLanguage: Uuid;
                languages: Uuid;
                regionalLanguageCode: Uuid;
                slug: Uuid;
                status: Uuid;
            };
        };
    };
};
export const duluxLocationPagesWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [DuluxLocationPagesWorkspaceCapabilityUdoTemplateKey.locationPage]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({
                cityName: uuidZodValidator,
                content: uuidZodValidator,
                defaultLanguage: uuidZodValidator,
                languages: uuidZodValidator,
                regionalLanguageCode: uuidZodValidator,
                slug: uuidZodValidator,
                status: uuidZodValidator,
            }),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<DuluxLocationPagesWorkspaceCapabilityUdoBindings>;
